import http from "@/http-common";

import {
  WSAbflusswerte,
  WSHauptwerteDateRange,
  WSWasserstand
} from "./interfaces";

class AbflussService {
  getMSWSAbflusswerte(ms_nr: number) {
    return http.get<Array<WSAbflusswerte>>(
      `data/messstellen_wasserstand_abflusswerte_30?w=messstellennummer=${ms_nr}`
    );
  }

  getMSWSDatumslist(ms_nr: number) {
    return http.get<Array<WSAbflusswerte>>(
      `data/messstellen_wasserstand_abflusswerte_datum?w=messstellennummer=${ms_nr}`
    );
  }
}

export const abflussService = new AbflussService();

class WasserstandService {
  getWasserstaende(ms_nr: number) {
    return http.get<Array<WSWasserstand>>(
      `data/messstellen_wasserstand_wasserstaende_30?w=messstellennummer=${ms_nr}`
    );
  }
}
export const wasserstandService = new WasserstandService();

class HauptwerteService {
  getHauptwerteMonat(ms_nr: number) {
    return http.get<Array<WSHauptwerteDateRange>>(
      `data/messstellen_wasserstand_hauptwerte_monat?w=messst_nr=${ms_nr}`
    );
  }
}
export const hauptwerteService = new HauptwerteService();

class StammdatenService {
  getStammdaten(ms_nr: number) {
    return http.get<Array<any>>(
      `data/messstellen_wasserstand_stammdaten?w=messstellennummer=${ms_nr}`
    );
  }
}
export const stammdatenService = new StammdatenService();
